module.exports = __webpack_public_path__ + "static/img/logo1.b1018fd9.png";